import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Spinner, IconButton } from "components/common";
import {
  GranteeInfo,
  GranteeListItemActions,
  GranteeListItemContainer,
  GranteeListItemTitle,
  StyledEntityCreateCapabilitySelect,
  StyledGranteeIcon
} from "components/permissions/CommonStyledComponents";
const CreateGranteesListItem = ({
  availableCapabilities,
  currentGranteeState,
  grantee: { id, capabilityId, type, title },
  onDelete,
  onCapabilityChange
}) => {
  const { t } = useTranslation("users");
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = () => {
    setIsDeleting(true);
    onDelete(id).then(() => setIsDeleting(false));
  };
  return /* @__PURE__ */ React.createElement(GranteeListItemContainer, { $currentState: currentGranteeState }, /* @__PURE__ */ React.createElement(GranteeInfo, { title }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, title)), /* @__PURE__ */ React.createElement(
    StyledEntityCreateCapabilitySelect,
    {
      onChange: (newCapabilityId) => onCapabilityChange({ granteeId: id, capabilityId: newCapabilityId }),
      capabilities: availableCapabilities,
      title: t("permissions.grantees.change_capability", { title }),
      value: capabilityId
    }
  ), /* @__PURE__ */ React.createElement(GranteeListItemActions, null, isDeleting ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "delete",
      onClick: handleDelete,
      title: t("permissions.grantees.remove_sharing", { title })
    }
  )));
};
export default CreateGranteesListItem;
